import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Shift = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Shift" {...props}>
    <path d="M12 1C12.5523 1 13 1.44772 13 2V11H19.5664L17.29 8.7041C16.9013 8.31194 16.9038 7.67888 17.2959 7.29004C17.6881 6.90125 18.3211 6.90383 18.71 7.2959L22.71 11.3311L22.7764 11.4043C22.9214 11.5829 23.001 11.807 23 12.0391C22.9988 12.3043 22.8924 12.5584 22.7041 12.7451L18.7041 16.71C18.3119 17.0987 17.6789 17.0962 17.29 16.7041C16.9013 16.3119 16.9039 15.6789 17.2959 15.29L19.6055 13H13V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V13H4.39454L6.70411 15.29C7.09618 15.6789 7.09874 16.3119 6.70997 16.7041C6.32114 17.0962 5.68807 17.0987 5.29591 16.71L1.29591 12.7451C1.10758 12.5584 1.00118 12.3042 1.00001 12.0391C0.998861 11.7739 1.10341 11.5194 1.29005 11.3311L5.29005 7.2959C5.67889 6.90382 6.31194 6.90126 6.70411 7.29004C7.0962 7.67888 7.09877 8.31194 6.70997 8.7041L4.4336 11H11V2C11 1.44773 11.4477 1.00002 12 1Z" fill="#000" />
  </StyledIcon>
));

Shift.displayName = 'Shift';

export { Shift };
